module.exports = __webpack_public_path__ + "img/Polisi.75907b10.jpg";